import { ChangeDetectionStrategy, AfterViewInit, Component, inject } from '@angular/core';
import {AuthGuardService} from '../../common/services/auth-guard.service';
import {Router} from '@angular/router';
import {Localization} from '../../../../projects/common/src/lib/interface/localization.extension';
import {StringsService} from '../../../../projects/common/src/lib/services/strings.service';
import {Title} from '@angular/platform-browser';
import {NotFoundType} from '../../common/enums/not-found-type.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-not-found-page',
  templateUrl: 'not-found.page.html',
  styleUrls: ['not-found.page.scss']
})
export class NotFoundPage extends Localization implements AfterViewInit {
  private authGuard = inject(AuthGuardService);
  private router = inject(Router);
  private titleService = inject(Title);


  type = '';
  types = NotFoundType;

  constructor() {

    super();
  }

  ngAfterViewInit(): void {
    let title = '404';
    switch (this.router.url) {
      case '/projectNotFound':
        this.type = NotFoundType.PROJECT_NOT_FOUND;
        title = this.getString('project_not_found');
        break;
      case `/${NotFoundType.SESSION_EXPIRED}`:
        this.type = NotFoundType.SESSION_EXPIRED;
        title = this.getString('session_expired');
        break;
      default:

        break;
    }
    this.titleService.setTitle(title);
    this.authGuard.loader.set(false);
    this.authGuard.loader$.next(false);
  }

  goToDashboard() {
    this.router.navigateByUrl('/dashboard');
  }
}
